import { NAME_SPACE as ns } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const SET_HOVER_LINE = `${ns}_SET_HOVER_LINE`;
